import React from "react";
import type { CashDisplayProps } from "./CashDisplay.types";

const CashDisplay: React.FC<CashDisplayProps> = ({
  cashBalance,
  className = "",
}) => {
  const isPositive = cashBalance >= 0;
  const roundedBalance = Math.round(Math.abs(cashBalance) * 100) / 100;

  return (
    <div className={`text-center ${className}`}>
      <div
        className={`text-4xl font-black tracking-tight lg:text-5xl ${
          isPositive ? "text-brand" : "text-expense"
        }`}
      >
        $
        {roundedBalance.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </div>

      <div className="mt-1 text-sm font-medium text-white/60 lg:text-base">
        {isPositive ? "Available cash" : "Cash deficit"}
      </div>
    </div>
  );
};

export default CashDisplay;
